/**
 * Pagination state for the browse index page.
 * Derived from the combination of user-controlled page/pageSize
 * and the server-returned totalCount.
 */
export interface PaginationState {
  /** Current page number (1-based, matching Koha API) */
  currentPage: number;

  /** Number of items per page (_per_page in Koha) */
  pageSize: number;

  /** Total number of matching records (from X-Total-Count header) */
  totalCount: number;

  /** Computed: Math.ceil(totalCount / pageSize) */
  totalPages: number;
}

/** Default pagination state on initial page load */
export const DEFAULT_PAGINATION: PaginationState = {
  currentPage: 1,
  pageSize: 9,      // 3×3 grid layout
  totalCount: 0,
  totalPages: 0,
};

/** Available page size options for the user to choose from */
export const PAGE_SIZE_OPTIONS = [9, 18, 36] as const;
